import _omit from 'lodash/omit';
import APPCONFIG from '../../../constants/Config';
import { CPM_REGISTER_CARPARK_TRIGGER } from '../../../constants/ActionTypes';

const initialSettings = APPCONFIG.cpmCarparkTrigger;
const carparkTrigger = (state = initialSettings, action) => {
  switch (action.type) {
    // REGISTER
    case CPM_REGISTER_CARPARK_TRIGGER:
      return {
        ...state,
        list: [...state.list, _omit(action, 'type')],
      };
    default:
      return state;
  }
};

export default carparkTrigger;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkTrigger.js